import { Box, Typography } from "@mui/material";
import React from "react";
import { MessageProps } from "../../../interfaces/all";
import { resolveMediaUrl } from "../../../utils/media";
import MessageAvatar from "./MessageAvatar";
import MessageMetaInfo from "./MessageMetaInfo";
import { MessageContainer, MessageContent } from "./styles";

const VideoMessage: React.FC<MessageProps> = ({
  message,
  showAvatar = true,
  showDate = true,
}) => {
  const isFromClient = message.sentBy === "client";
  const currentReadStatus = message.readStatus || { isRead: false };

  // Extrair dados do vídeo
  const content = message.content as any;
  const videoData = content.videoData || content.video || {};
  const rawUrl = videoData.url || videoData.mediaUrl || "";
  const url = resolveMediaUrl(rawUrl);
  const caption = videoData.caption || "";

  return (
    <MessageContainer isFromClient={isFromClient} showTriangle={showAvatar}>
      {isFromClient ? (
        <>
          <MessageAvatar sentBy={message.sentBy} showAvatar={showAvatar} />
          <MessageContent
            isFromClient={isFromClient}
            showTriangle={showAvatar}
            sx={{ p: 0.5, position: "relative", overflow: "hidden" }}
          >
            <Box
              sx={{
                width: "100%",
                maxWidth: 300,
                borderRadius: "8px",
                overflow: "hidden",
                bgcolor: "black",
              }}
            >
              {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
              <video
                src={url}
                controls
                crossOrigin="anonymous"
                style={{ width: "100%", display: "block", maxHeight: 400 }}
              />
            </Box>
            {caption && (
              <Box sx={{ p: 1, pb: 2.5 }}>
                <Typography variant="body2">{caption}</Typography>
              </Box>
            )}
            <MessageMetaInfo
              message={message}
              showDate={showDate}
              isFromClient={isFromClient}
              readStatus={currentReadStatus}
            />
          </MessageContent>
        </>
      ) : (
        <>
          <MessageContent
            isFromClient={isFromClient}
            showTriangle={showAvatar}
            sx={{ p: 0.5, position: "relative", overflow: "hidden" }}
          >
            <Box
              sx={{
                width: "100%",
                maxWidth: 300,
                borderRadius: "8px",
                overflow: "hidden",
                bgcolor: "black",
              }}
            >
              {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
              <video
                src={url}
                controls
                crossOrigin="anonymous"
                style={{ width: "100%", display: "block", maxHeight: 400 }}
              />
            </Box>
            {caption && (
              <Box sx={{ p: 1, pb: 2.5 }}>
                <Typography variant="body2">{caption}</Typography>
              </Box>
            )}
            <MessageMetaInfo
              message={message}
              showDate={showDate}
              isFromClient={isFromClient}
              readStatus={currentReadStatus}
            />
          </MessageContent>
          <MessageAvatar sentBy={message.sentBy} showAvatar={showAvatar} />
        </>
      )}
    </MessageContainer>
  );
};

export default VideoMessage;
